import React, { useEffect, useRef } from 'react';
import {
  FaInstagram,
  FaGoogle,
  FaYoutube,
  FaApple,
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhoneAlt,
  FaFax,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn
} from 'react-icons/fa';
import logo from "../../assets/Logo.svg"
import google2 from '../../assets/google2.svg'
import app2 from '../../assets/app2.svg'
import { Link } from 'react-router-dom';
import { useDashboard } from '../Context/Dashboardcontext';

const Footer = () => {
  const { contactDetails, fetchContactDetails } = useDashboard();
  const contactRef = useRef(null); // Ref for Contact component

  useEffect(() => {
    fetchContactDetails();
  }, []);

  const scrollToContact = () => {
    const el = document.getElementById("contact");
    el?.scrollIntoView({ behavior: "smooth" });
  };


  return (
    <footer className="bg-[#1A1D3A] text-white px-4 sm:px-6 md:px-20 py-10">
      {/* Main Footer */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-8 md:gap-12 pb-8 border-b border-gray-600">
        {/* Logo & Social */}
        <div className="order-1">
          <img src={logo} alt="Dispax Logo" className="w-40 sm:w-[212px] mb-4" />
          <p className="mb-2 font-semibold">FOLLOW US ON</p>
          <div className="flex space-x-4 text-xl">
            <a href={contactDetails?.instagram} target="_blank" rel="noopener noreferrer">
              <FaInstagram className="hover:text-gray-400 cursor-pointer" />
            </a>
            <a
              href={`mailto:${contactDetails?.email}?subject=Hello&body=I want to contact you`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaGoogle className="hover:text-gray-400 cursor-pointer" />
            </a>

            <a href={contactDetails?.youtube} target="_blank" rel="noopener noreferrer">
              <FaYoutube className="hover:text-gray-400 cursor-pointer" />
            </a>
            <a href={contactDetails?.apple} target="_blank" rel="noopener noreferrer">
              <FaApple className="hover:text-gray-400 cursor-pointer" />
            </a>
          </div>
        </div>

        {/* Information Links */}
        <div className="order-3 sm:order-2">
          <p className="mb-4 font-semibold">INFORMATION</p>
          <ul className="space-y-2 text-sm">
            <li><Link to='/cookies' className="hover:underline">Cookies Policy</Link></li>
            <li><Link to='/terms' className="hover:underline">Terms & Conditions</Link></li>
            <li><Link to='/contact' className="hover:underline">Contact us</Link></li>
            <li><Link to='/privacy' className="hover:underline">Privacy & Policy</Link></li>
            <li><Link to='/faq' className="hover:underline">FAQs</Link></li>
                        <li><Link to='/about-us' className="hover:underline">About us</Link></li>

          </ul>
        </div>

        {/* Contact Details */}
        <div className="order-2 sm:order-3 md:col-span-2 md:ml-24">
          <p className="mb-4 font-semibold">OUR DETAILS</p>
          <div className="text-sm space-y-3 max-w-md">
            <p className="flex items-start">
              <FaMapMarkerAlt className="mr-2 mt-1 flex-shrink-0" />
              <a
                href={contactDetails?.mapLink}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline"
              >
                {contactDetails?.address || "Address not available"}
              </a>
            </p>
            <p className="flex items-center">
              <FaEnvelope className="mr-2 flex-shrink-0" /> {contactDetails?.email || "Email not available"}
            </p>
            <p className="flex items-center">
              <FaPhoneAlt className="mr-2 flex-shrink-0" /> {contactDetails?.customerCarePhone || "Phone not available"}
            </p>
            {contactDetails?.fax && (
              <p className="flex items-center">
                <FaFax className="mr-2 flex-shrink-0" /> {contactDetails.fax}
              </p>
            )}
          </div>
        </div>

        {/* Mobile App */}
        <div className="order-4 flex flex-col items-start sm:items-end text-left sm:text-right justify-between">
          <p className="font-semibold mb-4">MOBILE APP</p>
          <div className="flex flex-col space-y-3">
            <a
              href={contactDetails?.google}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={google2} alt="Google Play" className="w-28 sm:w-32" />
            </a>
            <a
              href={contactDetails?.apple}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={app2} alt="App Store" className="w-28 sm:w-32" />
            </a>
          </div>

        </div>
      </div>

      {/* Bottom Bar */}
      <div className="flex flex-col items-center text-center md:flex-row md:justify-between mt-6 text-sm text-white">
        <p className="mb-4 md:mb-0">@Dispax, ALL RIGHTS RESERVED</p>
        <div className="flex space-x-4 text-white">
          <a href={contactDetails?.fb} target="_blank" rel="noopener noreferrer">
            <FaFacebookF className="hover:text-gray-400 cursor-pointer" />
          </a>
          <a href={contactDetails?.twitter} target="_blank" rel="noopener noreferrer">
            <FaTwitter className="hover:text-gray-400 cursor-pointer" />
          </a>
          <a href={contactDetails?.linkedIn} target="_blank" rel="noopener noreferrer">
            <FaLinkedinIn className="hover:text-gray-400 cursor-pointer" />
          </a>
          <a href={contactDetails?.instagram} target="_blank" rel="noopener noreferrer">
            <FaInstagram className="hover:text-gray-400 cursor-pointer" />
          </a>
          <a href={contactDetails?.youtube} target="_blank" rel="noopener noreferrer">
            <FaYoutube className="hover:text-gray-400 cursor-pointer" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
